/** @module csi/widget/NameValuePair */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"dojo/text!./NameValuePair.html",
	"csi/_base/underscore",
	"csi/html"
], function(declare, _TemplatedMixin, _WidgetBase, _WidgetsInTemplateMixin, template, _, html) {

	return declare([_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin], {
		templateString: template,

		/** @property {string} baseClass - CSS class used to style pair */
		baseClass: "csi-name-value-pair",

		/** @property {string} css to use for icon, such as "material-icons" or "far fa-XXX" */
		iconCss: "",

		/** @property {string} text to use for icon, i.e. if material icon */
		iconText: "",

		/** @property {string} tooltip for icon */
		iconTitle: "",

		/** @property {string} name */
		name: "",

		/** @property {string} separator=":" - text displayed between name and value */
		separator: ":",

		/** @property {string|_WidgetBase} [title] - widget or text for tooltip */
		title: "",

		/** @property {string} [titlePosition] - position for tooltip to override default */
		titlePosition: null,

		/** @property {string} value */
		value: "",

		/**
		 * Extension point called when widget is clicked
		 */
		onClick: function() { },

		/**
		 * Extension point called when icon is clicked
		 */
		onIcon: function() { },

		/**
		 * Setup tooltip if title is specified
		 */
		postCreate: function() {
			this.inherited(arguments);

			if (this.title) {
				this.tooltipNode.set("connectId", this.domNode);

				if (this.titlePosition) {
					this.tooltipNode.set("position", this.titlePosition);
				}

				if (_.isString(this.title)) {
					html.text(this.tooltipNode.domNode, this.title);
				} else {
					this.title.placeAt(this.tooltipNode);
				}
			}
		},

		/**
		 * Event handler for clicking on entire widget
		 * @param {Event} e
		 */
		_onClick: function(e) {
			this.onClick();
			e.stopPropagation();
		},

		/**
		 * Event handler for clicking on icon
		 * @param {Event} e
		 */
		_onIcon: function(e) {
			this.onIcon();
			e.stopPropagation();
		},

		/**
		 * Control visibility of name node based on name value
			 * @param {string} name
		 */
		_setIconCssAttr: function(value) {
			html.setVisible(this.iconNode, !!value);
			this._set("iconCss", value);
		},

		/**
		 * Control visibility of name node based on name value
			 * @param {string} name
		 */
		_setNameAttr: function(name) {
			html.setVisible(this.domNode.firstChild, !!name);
			html.text(this.nameNode, name);
			this._set("name", name);
		},

		/**
		 * Initialize tooltip with given title
			 * @param {string|_WidgetBase} title
		 */
		_setTitleAttr: function(title) {
			if (title) {
				this.tooltipNode.set("connectId", this.domNode);

				if (title.placeAt) {
					title.placeAt(this.tooltipNode);
				} else {
					html.text(this.tooltipNode.domNode, title);
				}
			}

			this._set("title", title);
		},

		_setValueAttr: {node: "valueNode", type: "innerText"}
	});
});